import { createBrowserRouter } from "react-router";
import { Home, LandingPage } from "../pages";
import { ErrorBoundaryLayout } from "./ErrorBoundaryLayout";
import { ProtectedRoute } from "./ProtectedRoute";
import { RoutePath } from "./RoutePath";

function ProtectedHome() {
    return (
        <ProtectedRoute>
            <Home />
        </ProtectedRoute>
    );
}
export const router = createBrowserRouter([
    {
        element: <ErrorBoundaryLayout />,
        children: [
            { path: RoutePath.Landing, Component: LandingPage },
            { path: RoutePath.Index, Component: LandingPage },
            { path: RoutePath.Home, Component: ProtectedHome },
            { path: RoutePath.All, Component: ProtectedHome },
        ],
    },
]);
